import { FC } from "react";
import { UserRegistrationSecondStep } from "../../../domain/models/dto/UserDTO";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";
import CustomInput from "../../../custom-components/form-inputs/CustomInput";
import CustomError from "../../../custom-components/form-inputs/CustomError";
import { userRegistrationSecondStepFields } from "../../../validation-schemas/user-schemas/UserRegistrationSchema";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import { setUserEmail } from "../../../slices/user-slice";

interface RegistrationSecondStepFormProps {
    form: FormikProps<UserRegistrationSecondStep>;
    error: string;
    foundUserEmail: string;
}

const RegistrationSecondStepForm: FC<RegistrationSecondStepFormProps> = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const registrationActionHandler = () => {
        props.form.handleSubmit();
    };

    const loginActionHandler = () => {
        dispatch(setUserEmail(props.foundUserEmail));
        navigate("/login");
    };

    return (
        <div className="relative w-full">
            <p className="H20 dmax2:H14 text-textFaded text-center mb-[50px] dmax2:mb-6">
                {t("registration.step2Name")}
            </p>
            <CustomInput
                form={props.form}
                name="firstName"
                fields={userRegistrationSecondStepFields}
                className="w-full h-[63px] dmax2:h-[45px] mb-3 dmax2:mb-2"
            />
            <CustomInput
                form={props.form}
                name="lastName"
                fields={userRegistrationSecondStepFields}
                className="w-full h-[63px] dmax2:h-[45px]"
            />
            <div className="mt-8">
                <CustomError form={props.form} errorKey={props.error} className="mb-4 text-center" />
                <div
                    className="button H20 dmax2:H14B w-full h-[60px] dmax2:h-[45px] cursor-pointer transition-all duration-300"
                    onClick={registrationActionHandler}
                >
                    <div className="mb-[2px]">{t("registration.registrationAction")}</div>
                </div>
            </div>
            {props.foundUserEmail && (
                <div className="mt-6">
                    <div
                        className="button H20 dmax2:H14B w-full h-[60px] dmax2:h-[45px] cursor-pointer transition-all duration-300"
                        onClick={loginActionHandler}
                    >
                        <div className="mb-[2px]">{t("login.loginAction")}</div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RegistrationSecondStepForm;
